var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require('@assets/dockingStationsMap/'+ _vm.icon_name +'.svg')}}),_c('div',{staticClass:"statistic-info"},[_c('h1',[_vm._v(_vm._s(_vm.data))]),_c('span',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }